import React from 'react';
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {BlueButton, GreenButton, OrangeButton} from "../common/ButtonsConstants";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, ExpandMoreTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {NotificationContainer, NotificationManager} from "react-notifications";
import moment from "moment";
import Accordion from "@material-ui/core/Accordion";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Grid from "@material-ui/core/Grid";
import MuiTable from "../common/MuiTable";
import {addSwmsRevision, deleteSwms, saveOrUpdateSwms, swms, swmsRevision} from "../../util/SwmsApiUtils";
import {exportReport, uploadFile} from "../../util/ApiUtils";
import SwmsPartOne from "./SwmsPartOne";
import SwmsPartTwo from "./SwmsPartTwo";
import {ACCESS_TOKEN, BOUND_USER_ID, V1_API_URL_PREFIX} from "../../Constants";
import Modal from "@material-ui/core/Modal";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import {Spinner} from "../common/Spinner";
import CommonRevisionModal from "../common/CommonRevisionModal";
import TableComponent from "../common/TableComponent";
import * as CommonUtils from "../../util/CommonUtils";
import SwmsHazards from "./SwmsHazards";
import CardContent from "@material-ui/core/CardContent";
import {saveOrUpdateImsAuditChecklist} from "../../util/ImsAuditChecklistApiUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

const columns = [
    {
        name: 'Company Name',
        id: 'companyName',
        type: "text",
    },
    {
        name: 'Address',
        id: 'address',
        type: "text",
    },
    {
        name: 'Project',
        id: 'project',
        type: "text",
    },
];

const muiColumns = [
    { title: 'Name', field: 'name', type: "string" },
    { title: 'Signature', field: 'signature', type: "signature", headerStyle: { width: "40%" } },
    { title: 'Job Title', field: 'jobTitle', type: "string", headerStyle: { width: "25%" } },
    { title: 'Date', field: 'date', type: "date", headerStyle: { width: "25%" } }
];

class Swms extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            id: null,
            companyName: "",
            address: "",
            abn: "",
            companyContact: "",
            position: "",
            phoneNumber: "",
            project: "",
            jobAddress: "",
            jobDescription: "",
            printName: "",
            signature: null,
            date: null,
            principalContractorName: "",
            principalContractorCompanyName: "",
            dateSwmsProvidedByContractor: null,
            contractorSignatureDate: null,
            contractorSignature: null,
            responsiblePersonName: "",
            responsiblePersonSignature: null,
            responsiblePersonDate: null,
            swmsRelatesTo: "",
            uploadedPhoto: null,
            uploadedFileName: null,
            uploadedFileId: null,
            relevantWorkers: [],
            isEditing: false,
            swmsList: [],
            isAutosaveRunning: false,
        };
        this.loadSwms = this.loadSwms.bind(this);
        this.saveSwms = this.saveSwms.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleAddRelevantWorker = this.handleAddRelevantWorker.bind(this);
        this.handleUpdateRelevantWorker = this.handleUpdateRelevantWorker.bind(this);
        this.handleDeleteRelevantWorker = this.handleDeleteRelevantWorker.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.isValid = this.isValid.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClear = this.onClear.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onFormChanged = this.onFormChanged.bind(this);
    }

    componentDidMount() {
        this.loadSwms();
    }

    addRevision(request) {
        addSwmsRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    loadSwms() {
        swms()
            .then(response => {
                console.log('response', response);
                this.setState({
                    swmsList: response,
                });
                swmsRevision()
                    .then( revisionResponse => {
                        this.setState({
                            latestRevision: revisionResponse,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }


    handleAddRow() {
        this.setState({
            id: null,
            companyName: "",
            address: "",
            abn: "",
            companyContact: "",
            position: "",
            phoneNumber: "",
            project: "",
            jobAddress: "",
            jobDescription: "",
            printName: "",
            signature: null,
            date: null,
            principalContractorName: "",
            principalContractorCompanyName: "",
            dateSwmsProvidedByContractor: null,
            contractorSignatureDate: null,
            contractorSignature: null,
            responsiblePersonName: "",
            responsiblePersonSignature: null,
            responsiblePersonDate: null,
            swmsRelatesTo: "",
            uploadedPhoto: null,
            uploadedFileName: null,
            uploadedFileId: null,
            relevantWorkers: [],
            hazards: [],
            hazardsWorkers: [],
            isEditing: true,
        });
    }

    onDelete(record) {
        deleteSwms(record)
            .then(() => {
                NotificationManager.success('Success', 'The SWMS record has been removed.', 5000);
            }).catch(error => {
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onFormChanged() {
        if (!this.state.isAutosaveRunning) {
            console.log("setting");
            this.setState({
                ...this.state, isAutosaveRunning: true
            });
            setTimeout(() => {
                console.log('Will be called after 5 minutes');
                this.saveSwms(true, this.state.hazards, this.state.hazardsWorkers);
                this.setState({
                    ...this.state, isAutosaveRunning: false
                });
            }, 300000);
            //clearTimeout(this.timer.current);
        } else {
            console.log("already running");
        }
    }

    saveSwms(isContinueEditing, hazards, hazardsWorkers) {
        const {
            companyName, address, abn, companyContact, position, phoneNumber, project, jobAddress, jobDescription, printName, date,
            principalContractorName, principalContractorCompanyName, dateSwmsProvidedByContractor, contractorSignatureDate, responsiblePersonName, responsiblePersonDate,
            swmsRelatesTo,

        } = this.form;
        console.log('dateSwmsProvidedByContractor', dateSwmsProvidedByContractor);
        const request = {
            id: this.state.id,
            companyName: companyName.value,
            address: address.value,
            abn: abn.value,
            companyContact: companyContact.value,
            position: position.value,
            phoneNumber: phoneNumber.value,
            project: project.value,
            jobAddress: jobAddress.value,
            jobDescription: jobDescription.value,
            printName: printName.value,
            signature: this.state.signature,
            date: moment(date.value, "DD/MM/YYYY"),
            principalContractorName: principalContractorName.value,
            principalContractorCompanyName: principalContractorCompanyName.value,
            dateSwmsProvidedByContractor: moment(dateSwmsProvidedByContractor.value, "DD/MM/YYYY"),
            contractorSignatureDate: moment(contractorSignatureDate.value, "DD/MM/YYYY"),
            contractorSignature: this.state.contractorSignature,
            responsiblePersonName: responsiblePersonName.value,
            responsiblePersonSignature: this.state.responsiblePersonSignature,
            responsiblePersonDate: moment(responsiblePersonDate.value, "DD/MM/YYYY"),
            swmsRelatesTo: swmsRelatesTo.value,
            relevantWorkers: this.state.relevantWorkers,
            hazards: hazards,
            hazardsWorkers: hazardsWorkers
        };
        console.log('state', this.state);
        console.log('saving request', request);
        let autoSave = this.state.isAutosaveRunning;
        saveOrUpdateSwms(request)
            .then((updatedSwms) => {
                console.log("updatedSwms id " + updatedSwms.id);
                console.log("updatedSwms " + updatedSwms);
                if (this.state.uploadedPhoto) {
                    const callback = (status, res) => {
                        console.log("result " + status);
                        console.log("result " + res);
                        if (status === 204) {
                            this.loadSwms();
                        } else {
                            console.log(res);
                        }
                    };
                    uploadFile("/swms/fileUpload", request.id, this.state.uploadedPhoto, callback);
                } else {
                    if (!autoSave) {
                        this.loadSwms();
                    }
                }
                if (!autoSave) {
                    NotificationManager.success('Success', 'The SWMS has been updated.', 5000);
                }
                if (!autoSave) {
                    this.setState({
                        isLoading: true,
                        isEditing: isContinueEditing,
                        isAutosaveRunning: false,
                    });
                } else {
                    this.setState({
                        //isLoading: true,
                        isEditing: isContinueEditing,
                        isAutosaveRunning: false,
                    });
                }
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onClear() {
        this.setState({
            id: null,
            companyName: "",
            address: "",
            abn: "",
            companyContact: "",
            position: "",
            phoneNumber: "",
            project: "",
            jobAddress: "",
            jobDescription: "",
            printName: "",
            signature: null,
            date: null,
            principalContractorName: "",
            principalContractorCompanyName: "",
            dateSwmsProvidedByContractor: null,
            contractorSignatureDate: null,
            contractorSignature: null,
            responsiblePersonName: "",
            responsiblePersonSignature: null,
            responsiblePersonDate: null,
            swmsRelatesTo: "",
            uploadedPhoto: null,
            uploadedFileName: null,
            uploadedFileId: null,
            relevantWorkers: [],
            hazards: [],
            hazardsWorkers: [],
        });
    }

    onEdit(swms) {
        window.scrollTo(0, 0);
        this.setState({
            isEditing: true,
            id: swms.id,
            companyName: swms.companyName,
            address: swms.address,
            abn: swms.abn,
            companyContact: swms.companyContact,
            position: swms.position,
            phoneNumber: swms.phoneNumber,
            project: swms.project,
            jobAddress: swms.jobAddress,
            jobDescription: swms.jobDescription,
            printName: swms.printName,
            signature: swms.signature,
            date: swms.date,
            principalContractorName: swms.principalContractorName,
            principalContractorCompanyName: swms.principalContractorCompanyName,
            dateSwmsProvidedByContractor: swms.dateSwmsProvidedByContractor,
            contractorSignature: swms.contractorSignature,
            contractorSignatureDate: swms.contractorSignatureDate,
            responsiblePersonName: swms.responsiblePersonName,
            responsiblePersonSignature: swms.responsiblePersonSignature,
            responsiblePersonDate: swms.responsiblePersonDate,
            swmsRelatesTo: swms.swmsRelatesTo,
            uploadedFileId: swms.uploadedFileId,
            uploadedFileName: swms.uploadedFileName,
            relevantWorkers: swms.relevantWorkers,
            hazards: swms.hazards,
            hazardsWorkers: swms.hazardsWorkers,
        });
    }

    onCancel() {
        this.setState({
            id: null,
            companyName: "",
            address: "",
            abn: "",
            companyContact: "",
            position: "",
            phoneNumber: "",
            project: "",
            jobAddress: "",
            jobDescription: "",
            printName: "",
            signature: null,
            date: null,
            principalContractorName: "",
            principalContractorCompanyName: "",
            dateSwmsProvidedByContractor: null,
            contractorSignatureDate: null,
            contractorSignature: null,
            responsiblePersonName: "",
            responsiblePersonSignature: null,
            responsiblePersonDate: null,
            swmsRelatesTo: "",
            uploadedPhoto: null,
            uploadedFileName: null,
            uploadedFileId: null,
            relevantWorkers: [],
            hazards: [],
            hazardsWorkers: [],
            isEditing: false,
        });
    }

    onSignatureDrawn(fieldName, sigPad) {
        console.log('onSignatureDrawn called', fieldName);
        this.setState({
            ...this.state, [fieldName]: sigPad.toDataURL('image/png')
        });
    }
    onImageUpload(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            uploadedPhoto: event.target.files[0],
        });
    }

    onDateChange(date, fieldName) {
        console.log('fieldName', fieldName); //whatever the date the user picked
        console.log('moment(date, "DD/MM/YYYY")', moment(date, "DD/MM/YYYY"));
        this.setState({
            ...this.state.swms, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    onChange(event) {
        console.log(event.target);
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }

    handleAddRelevantWorker(data) {
        console.log('add', data);
        let list = this.state.relevantWorkers;
        list.push(data);
        this.setState({
            relevantWorkers: list
        }, () => this.saveSwms(true,this.state.hazards, this.state.hazardsWorkers));
    }

    handleDeleteRelevantWorker(toDelete) {
        console.log('delete relevant worker', toDelete);
        let relevantWorkers = [];
        const index = this.state.relevantWorkers.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.relevantWorkers.length; i < l; i++) {
            if (i !== index) {
                relevantWorkers.push(this.state.relevantWorkers[i]);
            }
        }
        console.log("After removal:", relevantWorkers);
        this.setState({relevantWorkers: relevantWorkers}, () => this.saveSwms(true,this.state.hazards,this.state.hazardsWorkers));
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    handleUpdateRelevantWorker(toUpdate) {
        console.log("updating relevant workers to ", toUpdate);
        for (let i = 0, l = this.state.relevantWorkers.length; i < l; i++) {
            if (this.state.relevantWorkers[i].id === toUpdate.id) {
                this.state.relevantWorkers[i].signature = toUpdate.signature;
                this.state.relevantWorkers[i].jobTitle = toUpdate.jobTitle;
                this.state.relevantWorkers[i].date = toUpdate.date;
            }
        }
        console.log("After update:", this.state.relevantWorkers);
        this.saveSwms(true,this.state.hazards,this.state.hazardsWorkers);
    }

    isValid(data) {
        console.log('isValid', data);
        return true;
    }

    exportReport() {
        let request = new XMLHttpRequest();
        request.open('GET', V1_API_URL_PREFIX + "/swms/export", true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (localStorage.getItem(ACCESS_TOKEN)) {
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }

        if (localStorage.getItem(BOUND_USER_ID)) {
            request.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
        }
        request.responseType = 'blob';

        request.onload = function() {
            // Only handle status code 200
            if(request.status === 200) {
                const disposition = request.getResponseHeader('Content-Disposition');
                const filename =  disposition.split('filename=')[1];
                const contentType = request.getResponseHeader('Content-Type');


                // The actual download
                let blob = new Blob([request.response], { type: contentType });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);
            }
            // some error handling should be done here...
        };

        request.send(null);
    }

    render() {
        let { state } = this;
        if (state.isLoading) {
            return <Spinner/>;
        }

        let isRevision = !!state.latestRevision;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div ref={this.myRef}>
            <form ref={form => this.form = form}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {(state.isEditing ?
                    <React.Fragment>
                        <Accordion defaultExpanded>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreTwoTone />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ backgroundColor: 'blue', color: 'white'}}
                            >
                                <Typography component="h2" variant="h5">
                                    SAFE WORK METHOD STATEMENT (SWMS) - Part 1
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ padding: '0px' }}>
                                <Grid container spacing={0}>
                                    <SwmsPartOne state={state} onImageUpload={this.onImageUpload} onSignatureDrawn={this.onSignatureDrawn} onChangeHandler={this.onFormChanged}/>
                                    <Grid item xs={12} style={{ backgroundColor: 'lightblue'}}>
                                        <Typography component="h7" variant="subtitle1" style={{ padding: "10px", paddingLeft: "20px" }}>
                                            Relevant workers must be consulted in thex development, approval and communication of this SWMS
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                                        <Paper square>
                                            <MuiTable
                                                title="RELEVANT WORKERS CONSULTED IN THE DEVELOPMENT"
                                                columns={muiColumns}
                                                data={state.relevantWorkers}
                                                onAdd={this.handleAddRelevantWorker}
                                                onUpdate={this.handleUpdateRelevantWorker}
                                                onDelete={this.handleDeleteRelevantWorker}
                                                isValid={this.isValid}
                                                exportButton={false}
                                                search={false}
                                                pageSize={20}
                                                headerStyle={{ background: "lightblue" }}
                                            />
                                        </Paper>
                                    </Grid>
                                    <SwmsPartTwo state={this.state} onSignatureDrawn={this.onSignatureDrawn} onChangeHandler={this.onFormChanged}/>
                                </Grid>
                            </ExpansionPanelDetails>
                        </Accordion>
                        <SwmsHazards state={state} saveSwms={this.saveSwms} onChangeHandler={this.onFormChanged}/>
                        <Grid item xs={12}>
                            <OrangeButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleTwoTone />}
                                size="small"
                                onClick={this.onCancel}
                                style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                            >
                                CANCEL
                            </OrangeButton>
                            <GreenButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleTwoTone />}
                                size="small"
                                onClick={() => this.saveSwms(false,this.state.hazards,this.state.hazardsWorkers)}
                                style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                            >
                                SAVE
                            </GreenButton>
                            {/* TODO add functionality to export a single record */!isDemo && false && <OrangeButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleTwoTone />}
                                size="small"
                                onClick={this.exportReport}
                                style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px', float: "left" }}
                            >
                                Export
                            </OrangeButton>}
                        </Grid>
                    </React.Fragment>
                        :
                    <Paper className={classes.root} style={{ minWidth: '1000px'}}>
                        <Card className={classes.card}>
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor}
                                    >
                                        ADD
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                            </span>
                                }
                            />
                            <CardContent>

                        {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/swms/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                        <TableComponent
                            tableKey="swmsTable"
                            data={state.swmsList}
                            columns={columns}
                            handleSubmit={this.handleSubmit}
                            handleAddRow={this.handleAddRow}
                            handleRowDel={this.onDelete}
                            handleRowEdit={this.onEdit}
                            pagination={true}
                            allowAdd={!isAuditor ? 'show' : 'disable'}
                            allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                        />
                            </CardContent>
                        </Card>
                    </Paper>
                )}
            </MuiPickersUtilsProvider>
            </form>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={() => this.closeModal(null)}
            >
                <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
            </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(Swms);